export default "__VITE_PUBLIC_ASSET__7c687372__"